import { SVGProps } from 'react';

const SMSBubbleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="24" width="25" fill="none" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.48401 16.396C3.75401 15.096 3.33301 13.598 3.33301 12C3.33301 7.029 7.36201 3 12.333 3C17.304 3 21.333 7.029 21.333 12C21.333 16.971 17.304 21 12.333 21C10.735 21 9.23701 20.579 7.93701 19.849L3.33301 21L4.48401 16.396Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default SMSBubbleIcon;
